import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Angle from '../Angle';
import NavigationBreadcrumbsItemLabel from './NavigationBreadcrumbsItemLabel';

const propTypes = {
  crumb: PropTypes.shape({
    label: PropTypes.node.isRequired,
    path: PropTypes.string,
    ellipsis: PropTypes.bool,
    onClick: PropTypes.func,
    active: PropTypes.bool,
  }).isRequired,
  renderEllipsis: PropTypes.func,
  separator: PropTypes.oneOf(['arrows', 'bullets']),
};

const NavigationBreadcrumbItem = forwardRef(
  ({ crumb, separator, renderEllipsis }, ref) => {
    const { ellipsis, active } = crumb;

    const classes = classNames({
      'navigation-breadcrumbs-item': true,
      'navigation-breadcrumbs-item-ellipsis': ellipsis,
      'navigation-breadcrumbs-item-active': active,
    });

    const renderSeparator = () => {
      if (separator === 'bullets') {
        return (
          <span className="navigation-breadcrumbs-item-separator navigation-breadcrumbs-item-separator-bullet">
            &bull;
          </span>
        );
      }

      return (
        <Angle
          direction="right"
          className="navigation-breadcrumbs-item-separator"
        />
      );
    };

    if (ellipsis) {
      if (renderEllipsis) {
        return renderEllipsis({ renderSeparator });
      }

      return (
        <span className={classes}>
          <span className="navigation-breadcrumbs-item-label">&hellip;</span>
          {renderSeparator()}
        </span>
      );
    }

    return (
      <span className={classes} ref={ref}>
        <NavigationBreadcrumbsItemLabel crumb={crumb} />
        {renderSeparator()}
      </span>
    );
  },
);

NavigationBreadcrumbItem.propTypes = propTypes;
NavigationBreadcrumbItem.displayName = 'NavigationBreadcrumbItem';

export default NavigationBreadcrumbItem;
